import * as Yup from 'yup';

import { DEFAULT_REQUIRED_MESSAGE } from 'common/constants/copy';

export const institutionRequestSchema = Yup.object().shape({
  institutionName: Yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  website: Yup.string().required(DEFAULT_REQUIRED_MESSAGE),
  description: Yup.string(),
});
